import { render, staticRenderFns } from "./faceVideo.vue?vue&type=template&id=5370493e&scoped=true"
import script from "./faceVideo.vue?vue&type=script&lang=js"
export * from "./faceVideo.vue?vue&type=script&lang=js"
import style0 from "./faceVideo.vue?vue&type=style&index=0&id=5370493e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370493e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5370493e')) {
      api.createRecord('5370493e', component.options)
    } else {
      api.reload('5370493e', component.options)
    }
    module.hot.accept("./faceVideo.vue?vue&type=template&id=5370493e&scoped=true", function () {
      api.rerender('5370493e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/faceVideo.vue"
export default component.exports